import type { typeahead } from "@mirage/service-typeahead-search/service/types";
import DesktopApplicationIcon from "@mirage/shared/icons/DesktopApplicationIcon";
import i18n from "@mirage/translations";

import { BaseResultRow } from "./BaseResultRow";

export const DesktopApplicationResultRow = (props: {
  scoredResult: typeahead.ScoredDesktopApplication;
  isSelected: boolean;
}) => {
  const { result } = props.scoredResult;
  const { title } = result;

  return (
    <BaseResultRow
      icon={<DesktopApplicationIcon result={result} size={32} />}
      title={title}
      subtitle={i18n.t("desktop_application_subtitle")}
    />
  );
};
